import React, { memo } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { getAppDisplayName } from '@/utils/appBrand'

function index() {
    const { t } = useTranslation()
    return (
        <div className='cmp-rule'>
            {new Array(3).fill(0).map((_, i) =>
                <span key={i}>{t(`HostHonor.Rule.Rule${i}`, { APP: getAppDisplayName() })}</span>
            )}
        </div>
    )
}

export default memo(index)